(function(angular, schoolwork12) {
    'use strict';

    angular.module(schoolwork12.app.auth.name)
    .run(['$rootScope',
          '$location',
          'storage',
          schoolwork12.app.auth.services.authentication,
          schoolwork12.app.common.services.eventNotification,
          'Analytics',
          function ($rootScope, $location, storage, authentication, eventNotification, Analytics) {
              console.info('in auth-route-listener......');

              $rootScope.$on('$stateChangeStart',
                function(event, next, current) {
                    console.info('in auth-route-listener......'.concat(event.name).concat(next.url));
                    var currentUser = authentication.getCurrentUser();

                    // configure specific routes set up
                    var getStateRouteConfigurations = function (currentUser) {
                        var hasGradPlanManagerRole = authentication.hasGradPlanManagerRole();
                        var isSchoolActive  = authentication.isSchoolActive();
                        var isGradPlanOn  = authentication.isGradPlanOn();
                        $rootScope.hideManageGradPlan = false;
                        $rootScope.hideManageMailTemplate = false;
                        $rootScope.hideK12DataMngmt = false;
                        $rootScope.hideStudentSearch = false;
                        $rootScope.hideSchoolDataSearch = false;
                        $rootScope.hideCourseManagementSearch = false;
                        $rootScope.savedSearchObj = [];

                        var preventGradPlanAccess = (hasGradPlanManagerRole && isSchoolActive && isGradPlanOn) ? false : true;
                        console.info('let through');

                        if(next.url == '/login'){
                            Analytics.log;
                            $location.url(schoolwork12.app.student.routes.studentSearch);
                        }
                        // prevent gradPlan context access based on role, school and grad plan
                        else if (preventGradPlanAccess){
                            if ((next.url == '/manage-school-graduation-plans') ||
                                (next.url == '/add-school-graduation-plan') ||
                                (next.url == '/edit-school-graduation-plan')) {
                                    alert("Access to the Manage School Graduation Plans module has been denied due to insufficient permissions");
                                    event.preventDefault();
                                    $location.url(schoolwork12.app.student.routes.studentSearch);
                            }
                        }
                    }


                    if (currentUser) {
                        // invoke specific routes set up
                        getStateRouteConfigurations(currentUser);
                    }
                    else {
                        if (next.url != '/keycodeLogin' && next.url != '/loginError') {
                            var storeUserJson = storage.getData('X-API-TOKEN');

                            try {
                                // if promise isnt resolved, fetch stored keycode
                                var parsedJsonData = JSON.parse(storeUserJson);
                                if (storeUserJson && parsedJsonData['keycode']) {
                                    var storedKeycode = parsedJsonData['keycode'];
                                    console.info('route-listener: authenticated user is NULL. pull keycode from store: '.concat(storedKeycode));
                                    authentication.keycodeAuthenticate(storedKeycode)
                                        .then(function(user) {
                                            // invoke specific routes set up
                                            getStateRouteConfigurations(user);
                                        },
                                        function(error) {
                                            console.info('unable to keycodeAuth: '.concat(error));
                                            //SIS-1581: Removed the pfKeyCode in case its invalid
                                            document.cookie = "pfKeyCode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.k12.com"
                                            $location.url(schoolwork12.app.auth.routes.login);
                                        });
                                }
                                else{
                                     // Use this route config here , for student-grad-plan module
                                     // on Refresh click, student should be directed to /login error page
                                  if(next.url == '/student-graduation-plan-view') {
                                         $location.url('/loginError');
                                     } else {
                                          if (next.url !== "/login"){
                                            $location.url(schoolwork12.app.auth.routes.login);
                                          }
                                     }

                                }

                            }
                            catch (SyntaxError) {
                                console.error('error parsing stored keycode:'.concat(JSON.stringify(SyntaxError)));
                                 $location.url(schoolwork12.app.auth.routes.login);
                            }
                        } else if (next.url == '/loginError') {
                        	eventNotification.broadcast(schoolwork12.app.auth.events.userLoginError, authentication.getCurrentUser());
                        }
                    };
                })
            }
         ]);

}(angular, schoolwork12));
